import React from "react";

const Block = ({ className = "" }) => (
  <div className={`bg-[#141414] ${className}`} />
);

const Line = ({ className = "" }) => (
  <div className={`h-4 bg-[#2A2A2A] ${className}`} />
);

const ParagraphSkeleton = () => (
  <div className="mb-6 space-y-3">
    <Line className="w-full" />
    <Line className="w-full" />
    <Line className="w-[92%]" />
    <Line className="w-[96%]" />
    <Line className="w-[60%]" />
  </div>
);

const BlogSkel = () => (
  <main
    className="min-h-screen bg-[#050505] text-[#EDEAE1]"
    aria-busy="true"
    aria-live="polite"
  >
    <span className="sr-only">Loading article...</span>

    <article className="mx-auto max-w-6xl animate-pulse px-6 py-12 md:py-16">
      {/* Header */}
      <header className="mb-10 border-b-4 border-[#D0182B] pb-8">
        {/* Publisher + date */}
        <div className="mb-5 flex items-center gap-3">
          <div className="h-4 w-28 bg-[#D0182B]/60" />
          <span className="h-3 w-[2px] bg-[#8C8880]/50" />
          <div className="h-4 w-24 bg-[#2A2A2A]" />
        </div>

        {/* Title */}
        <div className="mb-6 space-y-3">
          <div className="h-10 w-full bg-[#2A2A2A] md:h-16" />
          <div className="h-10 w-3/4 bg-[#2A2A2A] md:h-16" />
        </div>

        {/* Author */}
        <div className="flex items-center gap-2">
          <div className="h-4 w-6 bg-[#8C8880]/30" />
          <div className="h-4 w-32 bg-[#2A2A2A]" />
        </div>
      </header>

      {/* Hero image */}
      <Block className="mb-12 h-[250px] w-full border border-[#2A2A2A] sm:h-[600px] md:h-[900px]" />

      {/* Prose */}
      <div className="w-full">
        <ParagraphSkeleton />
        <ParagraphSkeleton />

        {/* h2 */}
        <div className="mb-4 mt-14 border-l-4 border-[#D0182B] pl-4">
          <div className="h-7 w-2/3 bg-[#2A2A2A]" />
        </div>
        <ParagraphSkeleton />

        {/* Banner */}
        <Block className="my-10 h-[120px] w-full border border-[#2A2A2A] md:h-[180px]" />

        {/* Blockquote */}
        <div className="my-8 space-y-3 border-l-4 border-[#D0182B] bg-[#141414] py-4 pl-6 pr-4">
          <Line className="h-5 w-full bg-[#2A2A2A]" />
          <Line className="h-5 w-4/5 bg-[#2A2A2A]" />
        </div>

        <ParagraphSkeleton />
      </div>

      {/* Footer CTA */}
      <div className="my-16 border-t border-[#2A2A2A]">
        <div className="mt-16 flex flex-col items-center space-y-4 border border-[#2A2A2A] bg-[#141414] px-6 py-10">
          <div className="h-3 w-32 bg-[#D0182B]/50" />
          <div className="h-8 w-full max-w-md bg-[#2A2A2A]" />
          <div className="h-4 w-full max-w-xl bg-[#2A2A2A]" />
          <div className="h-10 w-32 border-2 border-[#D0182B]/60 bg-[#D0182B]/40" />
        </div>
      </div>
    </article>
  </main>
);

export default BlogSkel;